import { render, staticRenderFns } from "./CovidScreeningSmsSessions.vue?vue&type=template&id=5e2dd772&"
import script from "./CovidScreeningSmsSessions.vue?vue&type=script&lang=js&"
export * from "./CovidScreeningSmsSessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports